import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import './SideView.scss'; // Import the CSS file
import { useLocation } from 'react-router-dom';
// import useDisableBodyScroll from '../../../hooks/useDisableBodyScroll';

const SideView = ({ open, handleClose=()=>{}, headContent, footContent, children, className }) => {
    const location = useLocation();
    const [prevLocation, setPrevLocation] = useState(null);
    // useDisableBodyScroll(open);
    useEffect(() => {
        if (prevLocation && location.pathname !== prevLocation.pathname && open) {
            handleClose();
        }
        setPrevLocation(location);
      }, [location, prevLocation, open, handleClose]);

    return ReactDOM.createPortal(
        <div className={`side-view ${open ? 'open' : ''}`} >
            <div className={`side-view-overlay ${open ? 'open' : ''}`}  onClick={handleClose}></div>
            <div className={classNames(`side-view-content`, className, {open})}>
                {headContent && <div className="side-view-head">{headContent}</div>}
                <div className="side-view-body">
                    {open ? children : null}
                </div>
                {footContent && <div className="side-view-foot">{footContent}</div>}
            </div>
        </div>,
        document.body
    );
};

export default SideView;
